import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getIsFromBuilder = (state: IState) => {
  return pathOr(false, ['offerData', 'offer', 'isFromBuilder'], state);
};
